







































































import { Vue, Prop, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import ArrayToBase64Hash from "./helpers/ArrayToHash";
import { GET_STATE } from "./queries/getState";
import { GET_PRODUCTS } from "./queries/getProducts";
import { State, Question } from "@/types/DataSource";
import Loading from "@/components/Loading.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ButtonProfi from "@/components/ButtonProfi.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import ProductList from "@/components/ProductList.vue";
import TextBoxQuestion from "@/components/QuestionTypes/TextBoxQuestion.vue";
import TextBoxQuestionMulti from "@/components/QuestionTypes/TextBoxQuestionMulti.vue";
import DropdownQuestion from "@/components/QuestionTypes/DropdownQuestion.vue";
import ImageBoxQuestion from "@/components/QuestionTypes/ImageBoxQuestion.vue";
import ImageTextBoxQuestion from "@/components/QuestionTypes/ImageTextBoxQuestion.vue";
import Headline from "@/components/Headline.vue";

@Component({
  components: {
    "progressbar-profi": ProgressBar,
    "button-profi": ButtonProfi,
    "product-list": ProductList,
    loading: Loading,
    "error-message": ErrorMessage,
    selectText: TextBoxQuestion,
    multiSelectText: TextBoxQuestionMulti,
    dropDown: DropdownQuestion,
    selectImage: ImageBoxQuestion,
    selectImageText: ImageTextBoxQuestion,
    headline: Headline
  },
  apollo: {
    state: {
      query: GET_STATE,
      variables() {
        const parent = this.parentStateId;
        const profiId = this.productFinderId;
        const answersHash = this.answersHash;

        return {
          parentId: parent,
          productFinderId: profiId,
          answers: answersHash
        };
      },
      result(result) {
        if (!result.loading && result.data.state !== undefined) {
          this.stateId = result.data.state.id;
          this.currentStep = result.data.state.step;
          this.maxSteps = result.data.state.maxSteps;
          this.backgroundImageUrl = result.data.state.productFinder.image;
          try {
            this.$store.commit(
              "setColors",
              result.data.state.productFinder.colors
            );
          } catch (e) {
            this.showError = true;
          }
          try {
            this.$store.commit("setFont", result.data.state.productFinder.font);
          } catch (e) {
            this.showError = true;
          }

          try {
            this.$store.commit(
              "setConfig",
              result.data.state.productFinder.config
            );
          } catch (e) {
            this.showError = true;
          }

          if (result.data.state.page == null) {
            this.skipProductQuery = false;
          }
        }
      },
      error() {
        this.showError = true;
        this.handleReset();
      },
      skip() {
        return this.skipStateQuery;
      }
    },
    products: {
      query: GET_PRODUCTS,
      variables() {
        return {
          productFinderId: this.productFinderId,
          answers: this.answersHashProducts
        };
      },
      error() {
        this.showError = true;
        this.handleReset();
      },
      skip() {
        return this.skipProductQuery;
      }
    }
  }
})
export default class App extends Vue {
  @Prop() private productFinderId!: string;
  private stateId: Nullable<string> = null;
  private parentId: Nullable<string> = null;
  private skipStateQuery = true;
  private skipProductQuery = true;
  private state: Nullable<State> = null;
  private currentStep = 0;
  private maxSteps = 0;
  private backgroundImageUrl = "";
  private showError = false;
  private isAppInit = false;

  mounted() {
    if (this.productFinderId) {
      this.skipStateQuery = false;
      this.isAppInit = true;
    } else {
      this.showError = true;
      console.error("Please set a Product Finder Id");
    }

    this.$store.commit("setProductFinderId", this.productFinderId);

    //If set load last saved state from local storage
    const storedPreviousStates = localStorage.getItem(
      this.productFinderId + "_previousStates"
    );
    if (storedPreviousStates !== null) {
      this.$store.commit(
        "importPreviousStates",
        JSON.parse(storedPreviousStates)
      );
    }
    const storedCurrentParent = localStorage.getItem(
      this.productFinderId + "_currentParent"
    );
    if (storedPreviousStates !== null && storedCurrentParent !== null) {
      this.$store.commit(
        "importCurrentParent",
        JSON.parse(storedCurrentParent)
      );
    }
  }

  @Watch("showError")
  onShowErrorChanged(value: boolean): void {
    if (value === true) {
      setTimeout(this.hideError, 10000);
    }
  }

  private hideError(): void {
    this.showError = false;
  }

  get dynamicStyles() {
    return {
      "--background-image": "url('" + this.backgroundImageUrl + "')",
      "--app-container-background-color": this.$store.state.globalCss.colors
        .contentWrapperBgColor
    };
  }

  get showQuestions(): boolean {
    return (
      this.state !== null &&
      this.state !== undefined &&
      this.state.page !== null
    );
  }

  /**
   * Computed property that returns last state id from store
   *
   * @returns {Nullable<string>} Last state id or null value
   */
  get parentStateId(): Nullable<string> {
    const store = this.$store.state;

    if (store.currentParent !== null) {
      return store.currentParent.stateId;
    }

    const stateArray = store.previousStates;
    if (stateArray.length == 0) {
      return null;
    }

    const stateId = stateArray[stateArray.length - 1].stateId;

    return stateId;
  }

  /**
   * Computed property that returns last array of answers from store as base64 hash
   *
   * @returns {Nullable<string>} Resulting hash or null value
   */
  get answersHash(): Nullable<string> {
    const store = this.$store.state;
    const stateArray = store.previousStates;
    if (stateArray.length == 0) {
      return null;
    }

    let answers;
    if (store.currentParent !== null) {
      answers = store.currentParent.answers;
      if (answers == null) {
        return answers;
      }
    } else {
      answers = stateArray[stateArray.length - 1].answers;
    }

    return ArrayToBase64Hash(answers);
  }

  get answersHashProducts(): Nullable<string> {
    const store = this.$store.state;
    const stateArray = store.previousStates;
    const answers = Array<string>();
    stateArray.forEach((state: SavedState) => {
      state.answers?.forEach((answer: string) => {
        answers.push(answer);
      });
    });

    return ArrayToBase64Hash(answers);
  }

  /**
   * @returns All Questions for current page
   */
  get componentQuestions(): [Question] | null {
    if (this.state !== null && this.state.page !== null) {
      return this.state.page.questions;
    }

    return null;
  }

  /**
   * Checks if current state is first state
   * which disables the prevButton
   * @returns whether button should be disabled
   */
  get prevButtonDisabled(): boolean {
    const store = this.$store.state;

    if (store.previousStates.length === 0) {
      return true;
    } else if (store.previousStates.length >= 1) {
      if (
        store.currentParent !== null &&
        store.previousStates.findIndex((state: SavedState) => {
          return JSON.stringify(store.currentParent) == JSON.stringify(state);
        }) === -1
      ) {
        return true;
      }
    }

    return false;
  }

  get selectedAnswers(): Nullable<string>[] {
    const store = this.$store.state;

    if (store.currentParent !== null) {
      const answerIndex = store.previousStates.findIndex(
        (savedState: SavedState) => savedState.stateId === this.stateId
      );

      if (answerIndex !== -1) {
        return store.previousStates[answerIndex].answers;
      }
    } /* else if (this.answers !== null && this.answers.length > 0) {
      //If there's no previous state to get the selected answers from try to find the predetermined selected answer from the current state
      return this.answers.map((answer: AnswerOption) => answer.id);
    }*/ //Preselected answer selection (not yet implemented in db or schema)

    return [null];
  }

  get isLoading(): boolean {
    if (this.isAppInit && this.$apollo !== undefined) {
      return this.$apollo.loading;
    }

    return true;
  }

  /**
   * Pushes current state to previous states which initiates getting next state
   */
  private handleNext(answers: [string]): void {
    const store = this.$store.state;

    this.skipStateQuery = false;
    this.skipProductQuery = true;

    //CurrentParent set and CurrentParent is not second to last Element in previous List
    if (
      store.currentParent !== null &&
      store.previousStates.indexOf(store.currentParent) !==
        store.previousStates.length - 1
    ) {
      const currentParentIndex = store.previousStates.indexOf(
        store.currentParent
      );

      //Answers didn't change
      if (
        JSON.stringify(store.previousStates[currentParentIndex + 1].answers) ===
        JSON.stringify(answers)
      ) {
        this.$store.commit(
          "setCurrentParent",
          store.previousStates[currentParentIndex + 1]
        );
      } else {
        //Answers did Change
        const referenceState = store.previousStates.find(
          (savedState: SavedState) => savedState.stateId === this.stateId
        );
        this.$store.commit("removeStatesAfter", referenceState);
        this.$store.commit("resetCurrentParent");
      }
    } else if (
      //CurrentParent is set and it is second to last element in previous list
      store.currentParent !== null &&
      store.previousStates.indexOf(store.currentParent) ===
        store.previousStates.length - 1
    ) {
      this.$store.commit("resetCurrentParent");
    }

    //CurrentParent is not set
    if (store.currentParent === null) {
      this.$store.commit("addNewState", {
        stateId: this.stateId,
        answers: answers
      });
    }
  }

  /**
   * Sets current parent to previous parent in order to display the previous question
   */
  private handlePrevious(): void {
    const store = this.$store.state;
    //Default state for previousParent (calls initial question)
    let previousParent: SavedState = {
      stateId: null,
      answers: null
    };

    //CurrentParent is not set
    if (store.currentParent === null) {
      //Previous List has at least one element
      if (store.previousStates.length >= 2) {
        previousParent = store.previousStates[store.previousStates.length - 2];
      }
    } else {
      //CurrentParent is set
      const currentParentIndex = store.previousStates.findIndex(
        (state: SavedState) => {
          return JSON.stringify(store.currentParent) == JSON.stringify(state);
        }
      );

      //Get index of question previous to currentParent
      if (currentParentIndex >= 1) {
        previousParent = store.previousStates[currentParentIndex - 1];
      }
    }

    this.$store.commit("setCurrentParent", previousParent);

    //Reset which queries should be executed
    this.skipProductQuery = true;
    this.skipStateQuery = false;
  }

  /**
   * Calls reset mutation to set the profi to the original state
   */
  private handleReset(): void {
    this.$store.commit("resetStates");
    //Reset which queries should be executed
    this.skipProductQuery = true;
    this.skipStateQuery = false;

    //Reset local storage
    localStorage.removeItem(this.productFinderId + "previousStates");
    localStorage.removeItem(this.productFinderId + "currentParent");

    //ToDo
    // - Reset progress
  }

  private handleConsultation(): void {
    const win = window.open("https://www.aboutwaves.de/contact", "_blank");
    if (win) {
      win.focus();
    }
  }
}
